import{ useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { changeDateToString } from '../../utils/Date/SupportDate';

function RestaurentGlist(props) {
    const [tableData, setTabletData ] = useState([]);
    const [listRoom2Pax, setListRoom2Pax ] = useState([]);
    const [listRoom3Pax, setListRoom3Pax ] = useState([]);

    const dataGlist = useSelector(state => state.glist);
    const { listGuestStay , listGuestCheckOut, restaurant } = dataGlist;
    const dataBranchOnState = useSelector(state => state.dataPickUp.glist);

    useEffect(() => {
        function generateTableData() {
            const listRoom = [];
            const rooms2Pax = [];
            const rooms3Pax = [];
            restaurant.forEach(item => {
                if (!item.note.toUpperCase().includes("NBF")) {
                    listRoom.push(item.roomNumber);
                    const ampCount = (item.name.match(/&/g) || []).length;
                    if (ampCount === 1) rooms2Pax.push(item.roomNumber);
                    else if (ampCount >= 2) rooms3Pax.push(item.roomNumber);
                }
            });
            rooms2Pax.sort((a, b) => parseInt(a) - parseInt(b));
            rooms3Pax.sort((a, b) => parseInt(a) - parseInt(b));
            const rows = [];
            for (let i = 1; i <= 15; i++) {
                const row = [];
                for (let floor = 1; floor <= 6; floor++) {
                    const room = `${floor}${i.toString().padStart(2, '0')}`;
                    row.push(listRoom.includes(room) ? room : '');
                }
                rows.push(row);
            }
            setListRoom2Pax(rooms2Pax);
            setListRoom3Pax(rooms3Pax);
            setTabletData(rows);
        }
        if(listGuestStay && listGuestCheckOut) {
            generateTableData()
        }
    },[restaurant, listGuestStay, listGuestCheckOut])

    function toggleCell(rowIndex, cellIndex) {
        const newTableData = tableData.map(row => [...row]);

        if (newTableData[rowIndex][cellIndex]) {
            // CLEAR
            newTableData[rowIndex][cellIndex] = '';
        } else {
            // ADD → tự sinh room theo vị trí
            const roomNumber = `${cellIndex + 1}${(rowIndex + 1).toString().padStart(2, '0')}`;
            newTableData[rowIndex][cellIndex] = roomNumber;
        }

        setTabletData(newTableData);
    }


    return (<>
      <div style={{fontSize:'3.7rem', fontWeight: '600'}}>KITCHEN LIST ON {changeDateToString(dataBranchOnState.day)}</div>
        <table>
            <thead>
            <tr>
                <th style={{fontSize:"3.7rem", minWidth:"50px", border:"1px solid"}}>1F</th>
                <th style={{fontSize:"3.7rem", border:"1px solid"}}>2F</th>
                <th style={{fontSize:"3.7rem", border:"1px solid"}}>3F</th>
                <th style={{fontSize:"3.7rem", border:"1px solid"}}>4F</th>
                <th style={{fontSize:"3.7rem", border:"1px solid"}}>5F</th>
                <th style={{fontSize:"3.7rem", border:"1px solid"}}>6F</th>
            </tr>
            </thead>
            <tbody> 
            {tableData.map((row, i) => (
                <tr key={i} style={{ height: "70px" }}>
                {row.map((cell, j) => (
                    <td
                        key={j}
                        style={{
                            fontSize: "3.7rem",
                            border: "1px solid",
                            width: "150px",
                            // padding: "16px 8px",   // 👈 tăng padding
                            minHeight: "70px",    // 👈 ép ô cao hơn
                            fontWeight: "600",
                            textAlign: "center",
                            verticalAlign: "middle",
                        }} >
                        <div>{cell || "-"}</div>

                        <button
                            onClick={() => toggleCell(i, j)}
                            className="no-print"
                            style={{
                            marginTop: "4px",
                            fontSize: "1.6rem",
                            padding: "2px 8px",

                            cursor: "pointer",
                            background: cell ? "#ff4d4f" : "#52c41a",
                            color: "#fff",
                            border: "none",
                            borderRadius: "4px"
                            }}
                        >
                            {cell ? "Clear" : "Add"}
                        </button>
                        </td>
                    ))}
                    </tr>
            ))}
            </tbody>
        </table>

        <div style={{border:'1px solid', fontSize:'3rem', textAlign:'left', paddingLeft:'48px'}}>2 Pax : {listRoom2Pax.join(', ')}</div>
        <div style={{border:'1px solid', fontSize:'3rem', textAlign:'left', paddingLeft:'48px'}}>3 Pax : {listRoom3Pax.join(', ')}</div>
        </>)
}

export default RestaurentGlist;
